export default {
      id: "shipment-usage",
      viewBox: "0 0 35 35",
      url: __webpack_public_path__ + "img/icons.svg#shipment",
      toString: function () {
        return this.url;
      }
    }